/* eslint-disable max-len */
/* eslint-disable react/no-array-index-key */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Button, Form } from 'react-bootstrap5';
import { Formik } from 'formik';
import * as Yup from 'yup';

import Modal from 'components/new_ui/Modal/Modal';
import LoadingPlaceholder from 'components/new_ui/WaitLayers/LoadingPlaceholder';
import { Document, Page, pdfjs } from 'react-pdf';

import Actions from '../../Actions';

pdfjs.GlobalWorkerOptions.workerSrc = '/pdf.worker.js';

function formatDate(date) {
  const d = new Date(date);
  let month = `${d.getMonth() + 1}`;
  let day = `${d.getDate()}`;
  const year = d.getFullYear();

  if (month.length < 2) { month = `0${month}`; }
  if (day.length < 2) { day = `0${day}`; }

  return [year, month, day].join('-');
}

export default function ActivateModal({
  show, plan, onClose, onActivate,
}) {
  const [pdfFile, setPdfFile] = useState(null);

  const schema = Yup.object().shape({
    terms: Yup.bool().required().oneOf([true], 'Terms must be accepted'),
  });

  const onSubmit = (values, { setSubmitting }) => {
    setSubmitting(true);
    onActivate();
  };

  const values = {
    ...plan.attributes,
    effective_date: formatDate(plan.attributes.effective_date),
  };

  useEffect(() => {
    Actions.loadPdf(values, (pdf) => {
      setPdfFile(pdf);
    });
  }, []);

  return (
    <Modal show={show} size="lg">
      <b>Activate Policy</b>

      <p className="mt-3">
        Before activating your plan please review the Terms and Conditions of your Policy.
      </p>

      <div className="pdf-preview-wrapper">
        <Document
          file={pdfFile}
          renderMode="canvas"
          loading={<div>Please, wait ...</div>}
          externalLinkTarget="_blank"
        >
          {Array.from(new Array(3)).map((_, i) => (
            <Page
              pageNumber={i + 1}
              className="preview-pdf"
              renderAnnotationLayer
              renderTextLayer
              key={i}
            />
          ))}

        </Document>
      </div>

      <Formik
        validationSchema={schema}
        onSubmit={onSubmit}
        initialValues={{
          terms: false,
        }}
      >
        {({
          handleChange,
          handleSubmit,
          errors,
          isSubmitting,
        }) => (
          <Form noValidate onSubmit={handleSubmit}>

            <Form.Group className="mt-1">
              <Form.Check
                required
                name="terms"
                onChange={handleChange}
                label="I accept the Terms of the Talent Insurance Policy"
                isInvalid={!!errors.terms}
                feedback={errors.terms}
                feedbackType="invalid"
              />
            </Form.Group>

            <footer className="d-flex d-sm-block justify-content-center">
              <Button
                variant="outline-primary"
                onClick={() => onClose()}
              >
                Cancel
              </Button>

              <Button
                type="submit"
                disabled={isSubmitting}
              >
                {isSubmitting && <LoadingPlaceholder placement="inline" text=" " />}
                Activate
              </Button>
            </footer>
          </Form>
        )}
      </Formik>
    </Modal>
  );
}

ActivateModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onActivate: PropTypes.func,
  onClose: PropTypes.func,
  plan: PropTypes.object.isRequired,
};

ActivateModal.defaultProps = {
  onActivate: () => {},
  onClose: () => {},
};
